/**
 * CompanyLayout.jsx - Layout wrapper for B2B-kundesider
 * 
 * Denne layouten:
 * - Wrapper alt innhold med CompanyProvider for bedriftsdata
 * - Viser alltid CompanySidebar til venstre (låst/sticky)
 * - Rendrer barn (via Outlet) til høyre
 * 
 * Brukes som wrapper for alle /company/* ruter.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { CompanyProvider } from '../context/CompanyContext';
import CompanySidebar from './CompanySidebar';
import AIChatWidget from './AIChatWidget';

export default function CompanyLayout() {
  return (
    <CompanyProvider>
      <div className="min-h-screen bg-[#0F1419] flex" data-testid="company-layout">
        {/* Sidebar - fast posisjon, alltid synlig */}
        <CompanySidebar />
        
        {/* Hovedinnhold - tar resten av plassen med margin for sidebar */}
        <main className="flex-1 ml-64 min-h-screen overflow-y-auto">
          <Outlet />
        </main>

        {/* Kontekstuell AI-assistent */}
        <AIChatWidget />
      </div>
    </CompanyProvider>
  );
}
